<template>
  <div>
    <v-autocomplete
      :items="items"
      v-model="selectedheadOffice"
      label="Head Office"
      item-text="name"
      item-value="id"
      :clearable="clearable"
      @click:clear="clear"
      @input="onInput"
      @change="onChange"
      :outlined="outlined"
      :hide-details="hideDetails"
      :dense="dense"
      :disabled="disabled"
    ></v-autocomplete>
  </div>
</template>

<script>
import { HEAD_OFFICES_WITH_SUPPLIERS } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";

export default {
  name: "HeadOfficeListSelect",
  props: {
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    headOfficeId: { type: String },
    value: {
      type: String,
      default: () => "",
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectedheadOffice: this.value,
      suppliers: [],
    };
  },

  methods: {
    onChange(itemId) {
      console.log("change event", itemId);
      const selected = this.items.find((item) => item.id == itemId);
      if (selected) {
        this.$emit("onSelect", { ...selected });
      }
    },
    onInput(data) {
      this.$emit("input", data);
    },
    clear() {
      this.$emit("input", null);
      this.$emit("onClear");
    },
  },

  computed: {
    items() {
      return this.headOffices && this.headOffices.edges
        ? [...this.headOffices.edges.map(removeGQLTypename), ...this.suppliers]
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.selectedheadOffice = newVal;
    },
  },

  apollo: {
    headOffices: {
      query: HEAD_OFFICES_WITH_SUPPLIERS,
      result({ data }) {
        if (data.suppliers && data.suppliers.edges) {
          this.suppliers = [...data.suppliers.edges.map(removeGQLTypename)];
        }
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/HeadOfficeListSelect.vue